import { render, staticRenderFns } from "./dataBoard.vue?vue&type=template&id=5177b83c&scoped=true"
import script from "./dataBoard.vue?vue&type=script&lang=js"
export * from "./dataBoard.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/qualityStyle.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./dataBoard.vue?vue&type=style&index=1&id=5177b83c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5177b83c",
  null
  
)

export default component.exports